import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-maker-checker-view-dialog',
  templateUrl: './maker-checker-view-dialog.component.html',
  styleUrls: ['./maker-checker-view-dialog.component.css']
})
export class MakerCheckerViewDialogComponent {
  public fields: { key: string, value: string }[] = [];
  public isPending = false;
  public canApprove = false;
  public canReject = false;
  public showDecision = false;
  public isOwnRequest = false;
  public isMakerWithdraw = false;
  public reviewRemark = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<MakerCheckerViewDialogComponent>
  ) {
    this.isPending = data && data.status === 'PENDING';
    this.isOwnRequest = !!(data && data.isOwnRequest);
    this.isMakerWithdraw = !!(data && data.isMakerWithdraw);
    this.showDecision = !!(data && data.showDecision);
    this.canApprove = !!(data && data.canApprove);
    this.canReject = !!(data && data.canReject);
    this.fields = this.buildFields(data);
  }

  public close() {
    this.dialogRef.close();
  }

  public approve() {
    this.dialogRef.close({ action: 'approve', remark: this.reviewRemark || null });
  }

  public reject() {
    this.dialogRef.close({ action: 'reject', remark: this.reviewRemark || null });
  }

  private buildFields(data: any): { key: string, value: string }[] {
    const payload = data && data.payload;
    const pending = !!(data && data.status === 'PENDING');
    const labeled = Array.isArray(data && data.payloadFields) ? data.payloadFields : [];
    const used = {};
    const rows = [];
    labeled.forEach((field) => {
      used[field.key] = true;
      const value = payload && payload[field.key];
      rows.push({
        key: field.label || field.key,
        value: value == null || value === '' ? '--' : this.formatValue(field.key, value, pending)
      });
    });
    this.flatten(payload, pending).forEach((field) => {
      const root = field.key.split('.')[0];
      if (used[root] || used[field.key]) {
        return;
      }
      rows.push(field);
    });
    return rows;
  }

  private flatten(value: any, pending: boolean, prefix: string = ''): { key: string, value: string }[] {
    if (value === undefined || value === null || value === '') {
      return [];
    }
    if (typeof value !== 'object') {
      return [{ key: prefix || 'value', value: this.formatValue(prefix, value, pending) }];
    }
    if (Array.isArray(value)) {
      if (!value.length) {
        return [];
      }
      return [{ key: prefix || 'value', value: JSON.stringify(value) }];
    }
    const rows = [];
    Object.keys(value).forEach((key) => {
      if (key === 'negBalanceSelectedServicesAllowed') {
        return;
      }
      const nextKey = prefix ? prefix + '.' + key : key;
      const nested = this.flatten(value[key], pending, nextKey);
      nested.forEach((row) => rows.push(row));
    });
    return rows;
  }

  private formatValue(key: string, value: any, pending: boolean): string {
    const field = (key || '').split('.').pop();
    if (field === 'active') {
      const live = value ? 'Active' : 'Inactive';
      return pending ? live + ' (after approval)' : live;
    }
    if (typeof value === 'boolean') {
      return value ? 'Yes' : 'No';
    }
    if (Array.isArray(value)) {
      return JSON.stringify(value);
    }
    return String(value);
  }
}
